var React = require('react');

function IconItemCheaper (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"className":"icon-line--style icon-line--linecap","x":"27.84","y":"57.03","width":"50","height":"32","rx":"7","transform":"translate(-36.17 58.75) rotate(-45)","key":0}),React.createElement("circle",{"className":"icon-line--style icon-line--linecap","cx":"63.01","cy":"62.86","r":"5.29","key":1}),React.createElement("path",{"className":"icon-line--style icon-line--linecap","d":"M63,62.86S75.28,47.53,87,36.75s13.25-7.7,13.91-6.69C105.07,36.42,71.74,48.76,63,62.86Z","key":2})]));
}

IconItemCheaper.defaultProps = {"id":"icon-item-cheaper","viewBox":"0 0 128 128"};

module.exports = IconItemCheaper;

IconItemCheaper.default = IconItemCheaper;
